import { labelClasses } from './common';

const ImageUploadForm = ({ formSchema, fieldName, label, imagePreview, onNewImageStart, onNewImageLoaded, previewSize = 300 }) => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    onNewImageStart();

    if (!file) return;

    const reader = new FileReader();
    reader.onload = function(e) {
      onNewImageLoaded(e.target.result);
    }

    reader.readAsDataURL(file);
  }

  return (
    <div className="field">
      <label className={labelClasses(formSchema, fieldName)} htmlFor={fieldName}>{label}</label>
      {imagePreview && (
        <div style={{maxWidth: previewSize}} className="mb-2">
          <figure className="image is-4by3">
            <img
              className="is-clickable"
              src={imagePreview}
              alt="project preview" />
          </figure>
        </div>
      )}
      <div className="file">
        <label className="file-label">
          <input
            id={fieldName}
            className="file-input"
            type="file"
            accept="image/*"
            name="main-image"
            onChange={handleFileChange} />
          <span className="file-cta">
            <span className="_file-icon">
              <i className="fas fa-upload"></i>
            </span>
            <span className="file-label">
              Choose a new image
            </span>
          </span>
        </label>
      </div>
    </div>
  );
};

export default ImageUploadForm;
